import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PossibleDuplicatesLayer from "../components/User/PossibleDuplicatesLayer";

// Possible duplicates (founder decision 2026-10-13): review only.
const PossibleDuplicatesPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Possible Duplicates" />
      <PossibleDuplicatesLayer />
    </MasterLayout>
  );
};

export default PossibleDuplicatesPage;
